<template>
  <vl-properties-list v-vl-spacer:bottom.small>
    <vl-properties-label>{{ $t('entityAttribute.detail.id') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.id }}</vl-properties-data>
    <vl-properties-label>{{ $t('entityAttribute.detail.code') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.code }}</vl-properties-data>
    <vl-properties-label>{{ $t('entityAttribute.detail.label') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.label }}</vl-properties-data>
    <vl-properties-label>{{ $t('entityAttribute.detail.description') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.description }}</vl-properties-data>
    <vl-properties-label>{{ $t('entityAttribute.detail.order') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.order }}</vl-properties-data>
    <vl-properties-label>{{ $t('entityAttribute.detail.dataType') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.dataType.name }}</vl-properties-data>
    <vl-properties-label>{{ $t('entityAttribute.detail.length') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.length }}</vl-properties-data>
    <vl-properties-label>{{ $t('entityAttribute.detail.decimalCount') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.decimalCount || '-' }}</vl-properties-data>
    <vl-properties-label>{{ $t('entityAttribute.detail.isIdentifying') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.isIdentifying ? $t('general.yes') : $t('general.no') }}</vl-properties-data>
    <vl-properties-label>{{ $t('entityAttribute.detail.isMandatory') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.isMandatory ? $t('general.yes') : $t('general.no') }}</vl-properties-data>
    <vl-properties-label>{{ $t('entityAttribute.detail.isCalculated') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.isCalculated ? $t('general.yes') : $t('general.no') }}</vl-properties-data>
    <vl-properties-label>{{ $t('entityAttribute.detail.isDomain') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.isDomain ? $t('general.yes') : $t('general.no') }}</vl-properties-data>
    <template v-if="props.detail.isDomain">
      <vl-properties-label>{{ $t('entityAttribute.detail.allowedValues') }}</vl-properties-label>
      <vl-properties-data>
        <template v-for="(value, index) in allowedValues" :key="index">
          <div>{{ parseAllowedValue(value) }}</div>
        </template>
      </vl-properties-data>
    </template>
  </vl-properties-list>
</template>
<script lang="ts" setup>
import { EntityAttributeDetailDto } from '@/api/backoffice/clients';
import { dateFilter, dateTimeFilter } from '@/filters';
import { sortDomainValues } from '@/modules/configuration/common';
import { computed } from 'vue';
const props = defineProps<{
  detail: EntityAttributeDetailDto;
}>();

const allowedValues = computed(() => {
  return props.detail.allowedValues
    ? sortDomainValues(props.detail.allowedValues.toString().split(';'), props.detail.dataType.name)
    : [];
});

const parseAllowedValue = (value: string) => {
  if (props.detail.dataType.name === 'Vlag') {
    return value?.toString() === '1' ? 'True' : 'False';
  }
  if (props.detail.dataType.name === 'Datum + tijd') {
    return dateTimeFilter(value);
  }
  if (props.detail.dataType.name === 'Datum') {
    return dateFilter(value);
  }
  return value;
};
</script>
